import {ref, reactive, computed} from "vue";
import {defineStore} from "pinia";
import {getArticleName, getRubricName, getTransformArticles} from "@/stores/services/util";
import {LS} from "@/shared/services/translate";
import {DEFAULT_LANGUAGE_CODE, DEFAULT_USER_ROLE} from "@/shared/constants/consts";


export const useStatesStorage = defineStore('states-storage',  () => {
    const viewStates = reactive({
        show_preloader_spinner: true,
        show_preloader_article_spinner: true,
        save_in_process: false
    })

    return {viewStates}
})

export const useClientStorage = defineStore('client-storage',  () => {
    const clientObj = reactive({
        'lang': DEFAULT_LANGUAGE_CODE,
        'role': DEFAULT_USER_ROLE // admin
    });

    return {clientObj}
})

export const useTranslateStorage = defineStore('translate-storage',  () => {
    const language_strings = ref({});

    return {language_strings}
})

export const useRubricArticleStore = defineStore('rubric-article-storage',  () => {
    const rubric_id = ref();
    const article_id = ref();

    const rubrics = ref([]);
    const articles = ref([]);
    const article = ref(null);

    const nav_rubric_name = computed(() => {
        return getRubricName(rubrics.value, rubric_id.value)
    })

    const rubric_articles = computed(() => {
        return getTransformArticles(articles.value, rubric_id.value)
    })

    /*const other_rubric_articles = computed(() => {
        return rubric_articles.value.filter((v) => v.id != route.query.a)
    })*/

    const nav_article_name = computed(() => {
        return getArticleName(articles.value, article_id.value)
    })


    const updateRouteQuery = (new_rubric_id, new_article_id) => {
        rubric_id.value = new_rubric_id;
        article_id.value = new_article_id;
    }

    const transformRubrics = () => {
        let transform_rubrics = [];
        for(let i in rubrics.value) {
            let rubricObj = JSON.parse(JSON.stringify(rubrics.value[i]));
            rubricObj.name = LS(rubricObj.name);
            transform_rubrics.push(rubricObj);
        }

        return transform_rubrics;
    }

    return {
        rubric_id,
        article_id,
        rubrics,
        articles,
        article,
        nav_rubric_name,
        nav_article_name,
        rubric_articles,
        updateRouteQuery,
        transformRubrics
    }
})